import { render, staticRenderFns } from "./Wood.vue?vue&type=template&id=3188a762&scoped=true&"
import script from "./Wood.vue?vue&type=script&lang=js&"
export * from "./Wood.vue?vue&type=script&lang=js&"
import style0 from "./Wood.vue?vue&type=style&index=0&id=3188a762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3188a762",
  null
  
)

export default component.exports